import { EstadoBitacoraEnum, Venta } from "@/shared/interfaces"
import { Badge, Button, IconButton, Tooltip } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { calcularTiempoTranscurrido, cellNotFilter, formatDateWithTimeAMPM } from "@/shared";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { ChipModelState } from "@/shared/components/ui";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import ThreePOutlinedIcon from '@mui/icons-material/ThreePOutlined';
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";
import { openGenericObjectModalAsync } from "@/shared/components/ui/ModalGenericObject/useGenericObjectModalStore";
import { getCanalesVenta } from "@/shared/actions/erp";
import { fieldCanalVenta } from "@/shared/utils/fields-modal-generic-object";

type UseTableColumnsBitacoraState = {
  handle: (value: any) => void
  disabledAction?: boolean
}
export const useTableColumnsBitacora = ({
  handle,
  disabledAction = false
}: UseTableColumnsBitacoraState) => {

  const emitGetVentaById = useDiccionarioMotivo(s => s.emitGetVentaById);
  const setOpenRead = useDiccionarioMotivo(s => s.setOpenRead);
  const setOpen = useDiccionarioMotivo(s => s.setOpen);

  const columnsBitacoraPyl = useMemo<MRT_ColumnDef<Venta>[]>(() => [
    {
      enableColumnFilter: false,
      enableSorting: !disabledAction,
      accessorKey: 'accion',
      header: 'Acción',
      size: 50,
      Cell: ({ row }) => {
        return (
          <Tooltip placement="top" title="Crear Chat">
            <IconButton
              disabled={disabledAction}
              onClick={() => {
                handle(row.original)
                setOpen(true)
                emitGetVentaById(row.original.numero_referencia_venta)

              }}
            >
              <Badge
                variant="standard"
                color="primary"
                badgeContent={row.original.contado}
              //invisible={value.leido}
              >
                <ThreePOutlinedIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        )
      }

    },
    {
      accessorKey: 'nombre_cliente',
      header: 'cliente'
    },
    {
      accessorKey: 'identificacion_cliente',
      header: 'identificacion'
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo',
      header: 'Historial',
      Cell: ({ row }) => {

        return (
          <>
            <Button
              startIcon={<OpenInNewIcon />}
              color="primary"
              onClick={() => {

                emitGetVentaById(row.original.numero_referencia_venta)
                setOpenRead(true)
                setOpen(true)

              }}
            >
              VER
            </Button>
          </>
        )
      }
    },
    {
      accessorKey: 'estado_bitacora',
      header: 'Estado bitacora',
      Cell: ({ row }) => {
        return <ChipModelState
          label={row.original.estado_bitacora ?? 'N/A'}
          color={'info'}
        />
      }
    },
    {
      accessorKey: 'estado_venta',
      header: 'Estado venta',
      Cell: ({ row }) => {
        return <ChipModelState
          label={row.original.estado_venta ?? 'N/A'}
          color={'secondary'}
        />
      }
    },
   /*  {
      ...cellNotFilter,
      accessorKey: 'canal_venta',
      header: 'canal Venta',
      Cell: ({ row }) => {
        return <Button
          startIcon={<OpenInNewIcon />}
          onClick={() => {
            openGenericObjectModalAsync({
              fetcher: async () => {
                const resp = await getCanalesVenta({
                  codigo: row.original.canal_venta
                })

                return resp.data.data[0]
              },
              fields: fieldCanalVenta,
              title: 'Información',
            })
          }}
        >
          VER
        </Button>
      },
    }, */
    /* {
      ...cellNotFilter,
      accessorKey: 'vendedor',
      header: 'Asesor',
      Cell: ({ row }) => {
        return <InfoUser user={row.original.vendedor} />
      },
    }, */
    {
      accessorKey: "createdAt",
      header: "Fecha Creación",
      filterFn: "equals",
      Cell: ({ row }) => (formatDateWithTimeAMPM(row.original.createdAt)),
      Filter: ({ column }) => {
        const filterValue = column.getFilterValue() as string | undefined;
        return (
          <DatePicker
            format="YYYY-MM-DD"
            value={filterValue ? dayjs(filterValue) : null}
            onChange={(d: Dayjs | null) => {
              column.setFilterValue(d ? d.format("YYYY-MM-DD") : undefined);
            }}
            slotProps={{
              textField: {
                variant: "standard",   // estándar = sin outline
                label: undefined,      // sin label
                placeholder: "Selecciona fecha",
                InputLabelProps: { shrink: false },
                InputProps: { disableUnderline: true }, // quita la línea del standard
                sx: {
                  "& .MuiInputBase-root": {
                    border: "none",
                    background: "transparent",
                  },
                  "& fieldset": { border: "none" }, // por si cambia el variant
                },
              },
            }}
          />
        );
      },
    },

    {
      accessorKey: "updatedAt",
      header: "Ultima Modificación",
      filterFn: "equals",
      Cell: ({ row }) => (formatDateWithTimeAMPM(row.original.updatedAt)),
      Filter: ({ column }) => {
        const filterValue = column.getFilterValue() as string | undefined;
        return (
          <DatePicker
            format="YYYY-MM-DD"
            value={filterValue ? dayjs(filterValue) : null}
            onChange={(d: Dayjs | null) => {
              column.setFilterValue(d ? d.format("YYYY-MM-DD") : undefined);
            }}
            slotProps={{
              textField: {
                variant: "standard",
                label: undefined,
                placeholder: "Selecciona fecha",
                InputLabelProps: { shrink: false },
                InputProps: { disableUnderline: true },
                sx: {
                  "& .MuiInputBase-root": {
                    border: "none",
                    background: "transparent",
                  },
                  "& fieldset": { border: "none" },
                },
              },
            }}
          />
        );
      },
    },

    /* {
      accessorKey: 'createdAt',
      header: 'Fecha creación',
      Cell: ({ row }) => <>{formatDateWithTimeAMPM(row.original.createdAt)}</>,
    },
    {
      accessorKey: 'updatedAt',
      header: 'Ultima modificación',
      Cell: ({ row }) => <>{formatDateWithTimeAMPM(row.original.updatedAt)}</>,
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'tiempo_transcurrido',
      header: 'Tiempo transcurido',
      size: 225,
      Cell: ({ row }) => {
        const tiempo = calcularTiempoTranscurrido(row.original.updatedAt)
        //return <EstadoComponente backgroundColor={tiempo.color} texto={tiempo.texo} />
        return row.original.estado_bitacora == EstadoBitacoraEnum.FINALIZADO ? EstadoBitacoraEnum.FINALIZADO : `${tiempo.texo}`
      }
    },

  ], [])



  const columnsBitacoraVenta = useMemo<MRT_ColumnDef<Venta>[]>(() => [
    {
      enableColumnFilter: false,
      enableSorting: !disabledAction,
      accessorKey: 'accion',
      header: 'Acción',
      size: 50,
      Cell: ({ row }) => {
        return (
          <Tooltip placement="top" title="Crear Chat">
            <IconButton
              disabled={disabledAction}
              onClick={() => {
                handle(row.original)
                setOpen(true)
                emitGetVentaById(row.original.numero_referencia_venta)

              }}
            >
              <Badge
                variant="standard"
                color="primary"
                badgeContent={row.original.contado}
              //invisible={value.leido}
              >
                <ThreePOutlinedIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        )
      }

    },
    {
      accessorKey: 'nombre_cliente',
      header: 'cliente'
    },
    {
      accessorKey: 'identificacion_cliente',
      header: 'identificacion'
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo',
      header: 'Historial',
      Cell: ({ row }) => {

        return (
          <>
            <Button
              startIcon={<OpenInNewIcon />}
              color="primary"
              onClick={() => {

                emitGetVentaById(row.original.numero_referencia_venta)
                setOpenRead(true)
                setOpen(true)

              }}
            >
              VER
            </Button>
          </>
        )
      }
    },
    {
      accessorKey: 'estado_bitacora',
      header: 'Estado bitacora',
      Cell: ({ row }) => {
        return <ChipModelState
          label={row.original.estado_bitacora ?? 'N/A'}
          color={'info'}
        />
      }
    },
    {
      accessorKey: 'estado_venta',
      header: 'Estado venta',
      Cell: ({ row }) => {
        return <ChipModelState
          label={row.original.estado_venta ?? 'N/A'}
          color={'secondary'}
        />
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta',
      header: 'canal Venta',
      Cell: ({ row }) => {
        return <Button
          startIcon={<OpenInNewIcon />}
          onClick={() => {
            openGenericObjectModalAsync({
              fetcher: async () => {
                const resp = await getCanalesVenta({
                  codigo: row.original.canal_venta
                })

                return resp.data.data[0]
              },
              fields: fieldCanalVenta,
              title: 'Información',
            })
          }}
        >
          VER
        </Button>
      },
    },
    {
      ...cellNotFilter,
      accessorKey: 'vendedor',
      header: 'Asesor',
      Cell: ({ row }) => {
        return <InfoUser user={row.original.vendedor} />
      },
    },
    {
      accessorKey: "createdAt",
      header: "Fecha Creación",
      filterFn: "equals",
      Cell: ({ row }) => (formatDateWithTimeAMPM(row.original.createdAt)),
      Filter: ({ column }) => {
        const filterValue = column.getFilterValue() as string | undefined;
        return (
          <DatePicker
            format="YYYY-MM-DD"
            value={filterValue ? dayjs(filterValue) : null}
            onChange={(d: Dayjs | null) => {
              column.setFilterValue(d ? d.format("YYYY-MM-DD") : undefined);
            }}
            slotProps={{
              textField: {
                variant: "standard",   // estándar = sin outline
                label: undefined,      // sin label
                placeholder: "Selecciona fecha",
                InputLabelProps: { shrink: false },
                InputProps: { disableUnderline: true }, // quita la línea del standard
                sx: {
                  "& .MuiInputBase-root": {
                    border: "none",
                    background: "transparent",
                  },
                  "& fieldset": { border: "none" }, // por si cambia el variant
                },
              },
            }}
          />
        );
      },
    },

    {
      accessorKey: "updatedAt",
      header: "Ultima Modificación",
      filterFn: "equals",
      Cell: ({ row }) => (formatDateWithTimeAMPM(row.original.updatedAt)),
      Filter: ({ column }) => {
        const filterValue = column.getFilterValue() as string | undefined;
        return (
          <DatePicker
            format="YYYY-MM-DD"
            value={filterValue ? dayjs(filterValue) : null}
            onChange={(d: Dayjs | null) => {
              column.setFilterValue(d ? d.format("YYYY-MM-DD") : undefined);
            }}
            slotProps={{
              textField: {
                variant: "standard",
                label: undefined,
                placeholder: "Selecciona fecha",
                InputLabelProps: { shrink: false },
                InputProps: { disableUnderline: true },
                sx: {
                  "& .MuiInputBase-root": {
                    border: "none",
                    background: "transparent",
                  },
                  "& fieldset": { border: "none" },
                },
              },
            }}
          />
        );
      },
    },
    {
      ...cellNotFilter,
      accessorKey: 'tiempo_transcurrido',
      header: 'Tiempo transcurido',
      size: 225,
      Cell: ({ row }) => {
        const tiempo = calcularTiempoTranscurrido(row.original.updatedAt)
        //return <EstadoComponente backgroundColor={tiempo.color} texto={tiempo.texo} />
        return row.original.estado_bitacora == EstadoBitacoraEnum.FINALIZADO ? EstadoBitacoraEnum.FINALIZADO : `${tiempo.texo}`
      }
    },

  ], [])

  return {
    columnsBitacoraPyl,
    columnsBitacoraVenta
  }
}